const getDataDogReleaseVersion = () => process.env.VERCEL_GIT_COMMIT_SHA

module.exports = getDataDogReleaseVersion
